import { useEffect, useState } from "react";
import { useOps } from "./ui";

const ago = (iso) => {
  const s = Math.max(0, (Date.now() - new Date(iso).getTime()) / 1000);
  if (s < 60) return "just now";
  const units = [[86400, "day"], [3600, "hr"], [60, "min"]];
  const [n, u] = units.find(([n]) => s >= n);
  const v = Math.floor(s / n);
  return `${v} ${u}${v > 1 && u === "day" ? "s" : ""} ago`;
};
const short = (c) => (c || "").slice(0, 7);
const VERB = { ok: "deployed", rolled_back: "rolled back", rollback_failed: "deploy + rollback failed", failed: "deploy failed" };

export default function DeployBanner() {
  const { api } = useOps();
  const [d, setD] = useState(undefined);
  const [, tick] = useState(0);
  useEffect(() => {
    const load = () => api.get("/deploy/last").then((r) => setD(r.data)).catch(() => setD(null));
    load();
    const a = setInterval(load, 60000), b = setInterval(() => tick((t) => t + 1), 30000);
    return () => { clearInterval(a); clearInterval(b); };
  }, [api]);
  if (d === undefined) return null;
  if (!d) return <div data-testid="deploy-banner" className="mono border-b border-[#243144] px-3 py-1 text-[11px] text-slate-500">no automatic deploys yet</div>;
  const bad = d.result !== "ok";
  const commit = d.result === "failed" && d.to === "?" ? d.from : d.to;
  return (
    <div data-testid="deploy-banner" data-result={d.result} title={d.note || ""}
      className={`mono border-b px-3 py-1 text-[11px] ${bad ? "border-amber-500/40 bg-amber-500/10 text-amber-300" : "border-[#243144] text-slate-500"}`}>
      <span data-testid="deploy-banner-text">{VERB[d.result] || d.result} {ago(d.at)} · {short(commit)}</span>
      {d.result === "rolled_back" && <span data-testid="deploy-banner-live"> · live: {short(d.from)}</span>}
    </div>
  );
}
